const t = {
  "without-cc-form": "styles-module__without-cc-form___DH-jU",
  "tnc-checkbox-container": "styles-module__tnc-checkbox-container___qa7FQ",
  "terms-and-conditions": "styles-module__terms-and-conditions___OVC4c",
  "tnc-label": "styles-module__tnc-label___lXyih",
  continue: "styles-module__continue___8i87N"
};
export {
  t as default
};
